<template>
  <div class="restaurants">
    <section class="text-center">
      <h1 class="text-3xl text-gray-800 pt-6 mb-4">{{ $t('All Restaurants') }}</h1>
      <div class="mx-4 mb-3 h-12">
        <SearchBar @change="handleChange" />
      </div>
      <div
        v-for="(restaurant, index) in filteredRestaurants"
        :key="index"
        class="mx-4 rounded-lg bg-white shadow-lg mb-6 flex"
        @click="handleRestaurantClick(restaurant)"
      >
        <div class="w-full pl-4 pt-4 text-left text-gray-900">
          <div class="flex items-center mb-4">
            <eva-icon name="bookmark-outline" animation="pulse" width="30" height="30" fill="#F4AB27"></eva-icon>
            <h2 class="ml-3 text-2xl md:text-3xl">{{ restaurant.name }}</h2>
          </div>
          <div class="flex items-center mb-3">
            <eva-icon name="phone-call-outline" animation="pulse" width="30" height="30" fill="#23D25B"></eva-icon>
            <h2 class="ml-3 text-2xl md:text-3xl tracking-wider">{{ restaurant.phone | phone }}</h2>
          </div>

          <div class="flex items-center mb-4">
            <eva-icon name="home-outline" animation="pulse" width="30" height="30" fill="#384E77"></eva-icon>
            <h2 class="text-2xl ml-3">{{ restaurant.address }}</h2>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import { db } from '@/firebase';

export default {
  components: {
    SearchBar,
  },
  data() {
    return {
      restaurants: [],
      search: '',
    };
  },
  async created() {
    const restaurants = [];
    await db
      .collection('/restaurants/')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          restaurants.push({
            ...doc.data(),
            id: doc.id,
          });
        });
      });
    this.restaurants = restaurants;
  },
  methods: {
    handleRestaurantClick(restaurant) {
      this.$router.push({ name: 'RestaurantHome', params: { restaurantId: restaurant.id } });
    },
    handleChange(e) {
      this.search = e;
    },
  },
  computed: {
    filteredRestaurants() {
      const { search, restaurants } = this;
      if (search === '') {
        return restaurants;
      }
      return restaurants.filter(rest => rest.name.toLowerCase().includes(search.toLowerCase()));
    },
  },
};
</script>

<style></style>
